import "./DatePicker.constants.es.js";
import { jsx as e } from "react/jsx-runtime";
import { useMultiStyleConfig as i } from "@chakra-ui/react";
import { DatePickerComponent as c } from "./DatePicker.component.es.js";
import { useDatePicker as m, DatePickerStylesProvider as n, DatePickerProvider as s } from "./DatePicker.context.es.js";
const u = (r) => {
  const t = m(r), o = i("DatePicker", {});
  return /* @__PURE__ */ e(n, { value: o, children: /* @__PURE__ */ e(s, { value: t, children: /* @__PURE__ */ e(c, {}) }) });
};
export {
  u as DatePicker
};
//# sourceMappingURL=DatePicker.container.es.js.map
